export default {
  adminTitle: 'Služby a partneři',
  memberTitle: 'Výhody pro vlastníky',

  Preview: {
    title: 'Náhled nezveřejněného partnera',
    text: 'Partner {{name}} zatím není v katalogu zveřejněný – vidíte ho jen díky odkazu na náhled. Uživatelé ho neuvidí, dokud ho nezapnete v administraci.',
    none: 'Odkaz na náhled neodpovídá žádnému nezveřejněnému partnerovi – zobrazuje se běžný katalog.',
  },

  verifiedLink: 'Co znamená prověřený partner?',
  loadError: 'Katalog služeb se nepodařilo načíst. Zkuste to prosím znovu.',
  emptyState: 'Zatím tu pro vás nemáme žádnou nabídku.',
  emptyFilter: 'V této oblasti zatím nabídku nemáme.',

  Filter: {
    label: 'Co řešíte?',
    all: 'Vše',
  },

  Category: {
    finance: 'Pojištění a finance',
    energy: 'Energie',
    real_estate: 'Reality',
    construction: 'Stavba a zateplení',
    elevators: 'Výtahy',
    windows: 'Okna a dveře',
    cleaning: 'Úklid',
    parking: 'Parkování',
    legal: 'Právo',
    other: 'Ostatní',
  },

  Section: {
    internal: 'Služby eVlastníci',
    internalText: 'Naše vlastní divize – za tyhle služby ručíme přímo my.',
    partners: 'Prověření partneři',
    partnersText: 'Firmy, které známe z konkrétních projektů a doporučujeme je dál.',
  },

  Benefit: {
    label: 'Výhoda pro uživatele eVlastníků',
  },

  Badge: {
    internal: 'Služba eVlastníci',
    partner: 'Prověřený partner',
  },

  Card: {
    more: 'Zjistit více',
    offersCount_one: '{{count}} služba',
    offersCount_few: '{{count}} služby',
    offersCount_other: '{{count}} služeb',
  },

  CarApp: {
    eyebrow: 'Nová výhoda pro vlastníky',
    title: 'eVlastníci Auto',
    text: 'Aplikace pro vaše auto: spotřeba, náklady a hlídání termínů na jednom místě. Prémiovou verzi dostávají klienti eVlastníků zdarma.',
    features: ['Dálniční známka a pojištění', 'Pneu a servisní intervaly', 'Spotřeba a náklady', 'Kniha jízd pro OSVČ'],
    free: 'Prémiová verze zcela zdarma',
    action: 'Chci ji zdarma',
  },

  Verified: {
    title: 'Co znamená prověřený partner',
    intro: 'Do katalogu nebereme kdekoho. Označení „Prověřený partner eVlastníci" nese firma, u které platí:',
    items: [
      'Známe ji osobně a viděli jsme konkrétní realizace v bytových domech.',
      'Má transparentní ceník – žádné skryté výjezdy, příplatky ani čekání na „objednaný díl".',
      'Na poptávku z aplikace reaguje do 2 pracovních dnů.',
      'Sbíráme zpětnou vazbu od společenství. Partner, který ji nemá dobrou, z katalogu vypadne.',
    ],
    close: 'Rozumím',
  },

  Detail: {
    backToCatalog: 'Zpět na přehled služeb',
    whyWeRecommendInternal: 'Proč zrovna my',
    whyWeRecommendPartner: 'Proč je doporučujeme',
    signature: 'tým eVlastníci',
    whatYouGetInternal: 'Co pro vás uděláme',
    whatYouGetPartner: 'S čím vám pomohou',
    benefits: 'Co získáte',
    pitfalls: 'Co nejčastěji odhalíme',
    website: 'Web partnera',
    otherOffers: 'Další služby partnera',
    HowItWorks: {
      title: 'Jak to probíhá',
      step1Title: 'Pošlete poptávku',
      step1Text: 'Vyplníte pár údajů, dům k poptávce připojíme automaticky.',
      step2TitleInternal: 'Ozveme se vám',
      step2TitlePartner: 'Ozve se vám partner',
      step2Text: 'Do 2 pracovních dnů, telefonem nebo e-mailem – jak vám to vyhovuje.',
      step3Title: 'Dostanete nezávaznou nabídku',
      step3Text: 'Bez závazku a bez tlaku. Rozhodnete se, až budete mít všechna čísla.',
    },
  },

  Form: {
    title: 'Nezávazná poptávka',
    subtitleInternal: 'Ozveme se vám do 2 pracovních dnů. Bez závazku a bez tlaku.',
    subtitlePartner: 'Partner se vám ozve do 2 pracovních dnů. Bez závazku a bez tlaku.',
    interest: 'O co máte zájem',
    adminBuilding: 'Poptávka za dům',
    Fields: {
      contactName: { label: 'Jméno a příjmení', placeholder: 'Vaše jméno' },
      contactEmail: { label: 'E-mail', placeholder: 'vas@email.cz' },
      contactPhone: { label: 'Telefon', placeholder: '+420 777 123 456' },
      message: { label: 'Zpráva (nepovinné)', placeholder: 'Cokoli, co nám pomůže připravit nabídku na míru…' },
      attachments: { label: 'Přílohy (nepovinné)', hint: 'Např. stávající smlouva nebo fotky. Nejvýše 5 souborů, každý do 10 MB.', filesLabel: 'Vybrat soubory' },
    },
    consentRequired: 'Bez souhlasu s předáním údajů nemůžeme poptávku odeslat.',
    submit: 'Odeslat poptávku',
    submitting: 'Odesílám…',
    successTitle: 'Děkujeme, poptávku máme.',
    successText: 'Ozveme se vám do 2 pracovních dnů na uvedený telefon nebo e-mail.',
    successAgain: 'Poslat další poptávku',
    error: 'Poptávku se nepodařilo odeslat. Zkuste to prosím znovu.',
    invalid: 'Zkontrolujte prosím vyplněné údaje.',
    demoTitle: 'Poptávka není v demo verzi dostupná',
    demoText: 'V demu si můžete nabídky partnerů jen prohlédnout. Nezávaznou poptávku odešlete z plné verze aplikace po přihlášení do svého domu.',
    demoToApp: 'Přejít do plné verze',
  },
};
